// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

const items: { [key: string]: string[] } = {
    en: [
        'cheese',
        'coke',
        'toilet paper',
        'bread',
        'Pepsi',
        'bacon',
        'yogurt',
        'Pampers',
        'chicken',
        'cereal',
        'butter',
        'milk',
        'water',
        'pizza',
        'TV',
        'tide',
        'coffee',
        'chicken breast',
        'steak',
        'ground beef',
        'ice cream',
        'laptop',
        'cream cheese',
        'juice',
        'cucumber',
        'peanut butter',
        'orange juice',
        'dove',
        'Fitbit',
        'broccoli',
        'turkey',
        'Huggies',
        'ketchup',
        'pasta',
        'salmon',
        'watermelon',
        'cream',
        'PS4',
        'iPad',
        'tomato',
        'shrimp',
        'Xbox One',
        'tuna',
        'lettuce',
        'avocado',
        'car seat',
        'vacuum',
        'beef',
        'mayonnaise',
        'chocolate milk',
        'flour',
        'Keurig',
        'Tassimo',
        'margarine',
        'Tostitos',
        'tablet',
        'Becel',
        'apple',
        'ham',
        'Activia',
        'rice',
        'sour cream',
        'paint',
        'gain',
        'Tropicana',
        'oil',
        'olive oil',
        'christmas tree',
        'chocolate',
        'sugar',
        'LEGO',
        'Always',
        'BBQ',
        'soup',
        'coca cola',
        'pork',
        'bounty',
        'printer',
        'microwave',
        'Nutella',
        'Enfamil',
        'corn',
        'banana',
        'Charmin',
        'wonder bread',
        'shampoo',
        'Similac',
        'romaine',
        'Advil',
        'Pantene',
        'Dyson',
        'dishwasher',
        'iPad mini',
        'Colgate',
        'Gatorade',
        'cat litter',
        'Kraft Dinner',
        'Kraft',
        'Purex',
        'Smart TV',
        'cookie',
        'cat food',
        'Downy',
        'Christie',
        'Lysol',
        'camera',
        'Classico',
        'cauliflower',
        'pepper',
        'cashmere',
        'fan',
        'peaches',
        'pineapple',
        'celery',
        'axe',
        'dawn',
        'salad',
        'nestle',
        'Quaker',
        'sausage',
        'frozen fruit',
        'tea',
        'glade',
        'popcorn',
        'iPhone',
        'crest',
        'salsa',
        'sofa',
        'Delissio',
        'tortilla',
        'storage',
        'Royale',
        'bagel',
        'egg',
        'minute maid',
        'nestle water',
        'potato',
        'Eggo',
        'black diamond',
        'Aveeno',
        'bike',
        'fridge',
        'Nivea',
        'Kitchenaid',
        'spinach',
        'dog food',
        'Palmolive',
        'drill',
        'Nestea',
        'iogo',
        'Astro',
        'iPhone 6',
        'candy',
        'diaper',
        'Ziploc',
        'onion',
        'mushroom',
        'Swiffer',
        'Shopkins',
        'fish',
        'old spice',
        'jam',
        'mulch',
        'nature valley',
        'goldfish',
        'Nintendo Switch',
        'Gillette',
        'Kleenex',
        'Olay',
        'heater',
        'Heinz',
        'kale',
        'good start',
        'Pillsbury',
        'chair',
        'cracker barrel',
        'air conditioner',
        'humidifier',
        'PlayStation',
        'tissue',
        'roast',
        'toilet',
        'soap',
        'tent',
        'sunlight',
        'Wii U',
        'shed',
        'cascade',
        'orange',
        'facial tissue',
        'PAW patrol',
        'oatmeal',
        'glad',
        'herbal essence',
        'country harvest',
        'freezer',
        'Kotex',
        'Xbox',
        'McCain',
        'secret',
        'butterball turkey',
        'fleecy',
        'formula',
        'USB',
        'Tylenol',
        'Bose',
        'beer',
        'Febreze',
        'lemon',
        'pool',
        'shredded cheese',
        'slow cooker',
        'cake',
        'television',
        'honey',
        'treadmill',
        'mixer',
        'bed',
        'trimmer',
        'baby food',
        'patio',
        'soda',
        'food processor',
        'ninja',
        'fireplace',
        'duvet',
        'cake mix',
        'ensure',
        'special k',
        'cooler',
        'Samsung',
        'bounce',
        'dehumidifier',
        'Dewalt',
        'vanity',
        'Gerber',
        'fruit',
        'strawberry',
        'drone',
        'garage door opener',
        'ladder',
        'nerf',
        'Tampax',
        'apple juice',
        'LISTERINE',
        'mustard',
        'desk',
        'Vaseline',
        'iPod',
        'motor oil',
        'ActiFry',
        'pumpkin',
        'monitor',
        'halloween',
        'hair colour',
        'Samsung Tablet',
        'Rice Krispies',
        'sectional',
        'rug',
        'hard drive',
        'toaster oven',
        'Betty Crocker',
        'Air Wick',
        'canon',
        'refrigerator',
        'Unico',
        'Scott',
        'Cottonelle',
        'pomegranate',
        'dole',
        'silk',
        'Revlon',
        'bleach',
        'sauce',
        'table',
        'crib',
        'dryer',
        'sound bar',
        'TV stand',
        'lotion',
        'Garmin',
        'vim',
        'lamb',
        'Scotties',
        'detergent',
        'iPod touch',
        'whole chicken',
        'powerade',
        'foil',
        'Bluetooth',
        'tree',
        'watch',
        'laundry',
        'monster high',
        'tote',
        'shelf',
        'hair',
        'Bluetooth speaker',
        'crab',
        'high liner',
        'tarp',
        'Smartfood',
        'Venus',
        'lean cuisine',
        'saw',
        'hot dog',
        'Chromecast',
        'suave',
        'burger',
        'dresser',
        'Yoplait',
        'backpack',
        "Dempster's",
        'Bic',
        'meat',
        'ceiling fan',
        'barilla',
        'snow blower',
        'ottoman',
        'ivory',
        'mop',
        'compressor',
        'trampoline',
        'Maybelline',
        'Kashi',
        'Rubbermaid',
        'router',
        'PlayStation 4',
        'Neilson',
        'quality street',
        'Roku',
        'soil',
        'arm & hammer',
        'baby monitor',
        'CoverGirl',
        'Barbie',
        'hand soap',
        'Crayola',
        'battery',
        'vegetable oil',
        'frozen',
        'diet coke',
        'shaver',
        'Clorox',
        'hockey',
        'knife',
        'mascara',
        'hefty',
        'coconut water',
        'Villaggio',
        'dip',
        'LED',
        'viva',
        'laminate',
        'door',
        'paper',
        'Purina',
        'Pepperette',
        'halal',
        'Garnier',
        'creamer',
        'deep fryer',
        'flooring',
        'pancake',
        'comforter',
        'litter',
        'hair color',
        'shower head',
        'air compressor',
        'grape',
        'tile',
        'grill',
        'degree',
        'Nintendo',
        'snuggle',
        'generator',
        'laser printer',
        'off',
        'computer',
        'kiwi',
        'extension cord',
        'mirror',
        'coffee table',
        'snowblower',
        'Knorr',
        'pop',
        'call of duty',
        'condensed milk',
        'taco',
        'external hard drive',
        'rice cooker',
        'VH',
        'pure leaf',
        'carrot',
        'mitre saw',
        'kobo',
        'laughing cow',
        'hose',
        'bench',
        'Playtex',
        'chip',
        'Reactine',
        'range',
        'sharpie',
        'Nespresso',
        'wonder',
        'LED TV',
        'maple syrup',
        'speaker',
        'stuffing',
        'target',
        'desktop',
        'evaporated milk',
        'table saw',
        'go pro',
        'salt',
        'halloween candy',
        'garlic',
        'Kraft peanut butter',
        'Oreo',
        'cordless phone',
        'bedding',
        'centrum',
        'brie',
        'drumstick',
        'Schick',
        'sleeping bag',
        'Nike',
        'salami',
        'oven',
        'golf',
        'soundbar',
        'pudding',
        'Clamato',
        'projector',
        'dial',
        'pedigree',
        'folding table',
        'fruite',
        'plum',
        'wine',
        'lamp',
        'ground pork',
        'jack',
        'shovel',
        'Instax',
        'air bed',
        'Sony',
        'energizer',
        'instant coffee',
        'bra',
        'nectarine',
        'light',
        'keyboard',
        'ice tea',
        'Nikon',
        'espresso',
        'gluten free',
        'gravy',
        'Roomba',
        'dining table',
        'hamburger',
        'stand mixer',
        'ristorante',
        'Iams',
        'sodastream',
        'Mazola',
        'Tenderflake',
        'gum',
        'nest',
        'pear',
        'recliner',
        'smoked salmon',
        'BBQ sauce',
        'pie',
        'dishwasher detergent',
        'Norton',
        'LED bulb',
        'binder',
        'Jamieson',
        'hand mixer',
        'whipping cream',
        'smoker',
        'pot of gold',
        'phone',
        'Acer',
        'Aunt Jemima',
        'bud light',
        'cabinet',
        'cat',
        'baby gate',
        'juicer',
        'karaoke',
        'popsicle',
        'iRobot',
        'dove soap',
        'synthetic oil',
        'blueberry',
        'kitchen table',
        'mayo',
    ],
    fr: [
        'Fromage',
        'Œufs',
        'Poulet',
        'Lait',
        'Pain',
        'Yogourt',
        'Beurre',
        'Jouets',
        'Bacon',
        'Croustilles',
        'Raisin',
        'Crème glacée',
        'Shampooing',
        'Pizza',
        'Couches',
        'Eau',
        "Beurre d'arachide",
        'TV',
        'Concombre',
        'Poitrine de poulet',
        'Fraises',
        'Café',
        'Jus',
        "Jus d'orange",
        'Œuf',
        'Boisson gazeuse',
        'Portable',
        'Tomate',
        'Laitue',
        'Lait au chocolat',
        'Banane',
        'Dentifrice',
        'Pomme',
        'Nivea',
        'Pâtes',
        'Ketchup',
        'Brocoli',
        'Dinde',
        'Écouteurs',
        'Bœuf',
        'Tomates',
        'Pastèque',
        'Imprimeur',
        'Poivre',
        'Bonbons',
        'pommes',
        'Déodorant',
        'crème sure',
        'boisson gazeuse',
        'Thon',
        'Crème',
        'pousses',
        'Farine',
        'Riz',
        'Saumon',
        'Téléphones',
        'Parfum',
        'dossier de fichiers coloré',
        'détergent à lessive',
        'Pomme De Terre',
        'Sucre',
        'Pommes de terre',
        'piles',
        'Champignon',
        'poivrons',
        'Arbre De Noël',
        'Haricots',
        'Barbecue',
        'Pneus',
        'Chaussures',
        'maïs',
        'appareil photo',
        'noyer cendré',
        'Soupe',
        'Framboises',
        'Céleri',
        'Avocat',
        'aliments pour bébés',
        "Huile D'Olive",
        'Sauce pour pâtes',
        'aspirateur',
        'Romaine',
        'Bagel',
        'Huile',
        'Mayonnaise',
        'Viande de porc',
        "manteaux d'enfants",
        'Chou-Fleur',
        'Margarine',
        'Oignons',
        'Oignon',
        'Viande à hamburger',
        'Glacière',
        'Tortilla',
        'Bleuets',
        'Ananas',
        'Biscuit',
        'Cheminée',
        'Oranges',
        'Papier hygiénique',
        'Voiture',
        'Jambon',
        'Bottes',
        'Asperges',
        'Glucosamine',
        'Bijou',
        'Fraise',
        'CRACKERS',
        'Litière Pour Chat',
        'Craquelins',
        'Tablette',
        'Perceuse',
        'Arbre',
        'Jambon Fumé',
        'Geler',
        'Poivrons',
        'Canada',
        'Peinture',
        'Bananes',
        'Lingettes',
        'Cerises',
        'Crevette',
        'fruits surgelés',
        'Souffleuse à neige',
        'Nourriture',
        'Champignons',
        'boissons gazeuses',
        'tablettes',
        'essuie-tout',
        'Haut-parleurs',
        'Carottes',
        'Nourriture pour chats',
        'bleuet',
        'Piscines',
        "lait d'amande",
        'mouchoir',
        'Essuie-glace',
        'Citrouille',
        'Orange',
        'Bagels',
        'Pêches',
        'Fromage en tranche',
        'Télévision',
        'Bébé',
        'Humidificateur',
        'Eau en bouteille',
        'Nourriture pour chiens',
        'Linge',
        'clémentine',
        'Salade',
        'Poisson',
        'cidre de pomme',
        'Frites',
        'Dinde Butterball',
        'Carotte',
        'Clavier',
        'Savon',
        'Roses',
        'Salsa',
        'Déshumidificateur',
        'Thé',
        'Ventilateur',
        'Tente',
        'Papier',
        'Micro-onde',
        'Toilette',
        'Saucisse',
        'Viande de porc',
        'Chocolat Chaud',
        'Crayons',
        'De fromage râpé',
        'Détergent',
        'Échelle',
        'Oncle',
        'Confiture',
        'Sauce',
        'Croustilles',
        'soie dentaire',
        'pépites de chocolat',
        'Lumières',
        'Chocolat',
        "Bottes d'hiver",
        'Piscine',
        'Gâteau',
        'Lingette pour bébés',
        'Mélange à gateau',
        'Viande',
        'poivron vert',
        'Épinards',
        'Halloween',
        'Vélo',
        'Raisin',
        'Convection',
        'Fruit',
        'Ivory',
        'climatiseur',
        'Ensure',
        'Guimauves',
        'Crème à café',
        'Concombres',
        'Craquelins de riz',
        'Smart TV',
        'Tide Boost',
        'Grenade',
        'Popcorn',
        'papier hygiénique',
        'Matelas',
        'Crabe',
        'Sel',
        'Tortillas',
        'Pêche',
        'Lave-Vaisselle',
        'Ordinateur',
        'Frigo',
        'Tentes',
        'Savon à vaisselle',
        'Miel',
        'Meubles',
        'Ail',
        'Batterie',
        'Congélateur',
        'Cerise',
        'Pelle',
        'Pull Ups',
        'Tapis',
        'Réfrigérateur',
        'Poires',
        'Vinaigrette',
        'Lumieres De Noel',
        'Moutarde',
        'Cachemire',
        'Patate Douce',
        'Patates Douces',
        'Litière',
        'Lingettes pour bébés',
        'Jus De Pomme',
        'Hockey',
        'Mayo',
        'Neige',
        'Eau dentifrice',
        'Eau Purifiée',
        "Flocons d'avoine",
        'Barre Granola',
        'Citron',
        'Souffleuse à neige',
        'Javellisant',
        'chat',
        'médicament pour enfant',
        'baignoires',
        'Sac à dos',
        'Chou frisé',
        'Chiffons',
        'Destin',
        'Rasoir Électrique',
        'Jeu FIFA Soccer vidéo',
        'Vêtements',
        'Jeux',
        'Encre',
        'Prune',
        'assiettes',
        'grille-pain four',
        'Gaufres',
        'tricycle',
        'Engrais',
        'petit pain',
        'Pâques',
        'Micro SD',
        'Pluie',
        'Lotion',
        'Poulet haché',
        'Haricot Vert',
        'Trampoline',
        'Sol',
        'Grecque',
        'Organique',
        'Belvédère',
        'Légumes',
        'Agneau',
        'Cantaloup',
        'Poire',
        'Mangue',
        'Amande',
        'Tampon',
        'Baies',
        'Mélangeur',
        'Aile de poulet',
        'Scie',
        'Coffre',
        'Cornichon',
        'Chou',
        'Fichier',
        'muesli',
        'Nettoyeur',
        'Fourre-tout',
        'Zucchini',
        'Arachide',
        'Gril',
        'Cheveux',
        'Houmous',
        'Rasoir',
        'Brosse dents A',
        'Fixatif',
        'Robinet',
        'Casque',
        'Parmesan',
        'Souris',
        'Salle de bain',
        'Déjeuner',
        'Pudding',
        'Routeur',
        'Gravy',
        'Mascara',
        'Espadrilles',
        'Bagage',
        'Charbon',
        'Céréales pour bébés',
        'Homard',
        'USB',
        'Noix de coco',
        'Tomate raisin',
        'Quinoa',
        'Bière',
        'Bouilloire',
        'Côtellete de porc',
        'Elliptique',
        'Équipement',
        'Chaise',
        'Gomme',
        'Poussette',
        'Semence de gazon',
        'Melon',
        'Côte de bœuf',
        'Chaussures de sécurité',
        'Garage',
        'Boîte de jus',
        'Écran solaire',
        'Sirop',
        'Tronçonneuse',
        'Fromage feta',
        'Tuyau',
        'Vinaigrette',
        'Casque à écouteurs',
        'Citron vert',
        'Bain',
        'Tondeuse à gazon',
        'Grille-pain',
        'Râteau',
        'Mortadelle',
        'Filet',
        'Lit',
        'Chien',
        'Aubergine',
        'Pamplemousse',
        'Dinde hachée',
        'Pepperoni',
        'Tarte',
        'Sofa',
        'Sprite',
        'Gala',
        'Jello',
        'Jambon en spirale',
        'Vision',
        'Glaçage',
        'Maquillage',
        'Nettoyage',
        'Table',
        'Cuisse de poulet',
        'Téléphone',
        'Poulet',
        'Soda au gingembre',
        'Kiwi',
        'Protéine',
        'Tilapia',
        'Saucisse',
        'Porte',
        'Led',
        'Fleurs',
        'Serviettes',
        'Ricotta',
        'Sports',
        'Pellicule',
        'Balai',
        'Cassonade',
        'Ordures',
        'Épicerie',
        'Lessive',
        'Viande pour lunch',
        'Poivron rouge',
        'Muffin anglais',
        "Tuyau d'arrosage",
        'Fromage à effilocher',
        'Sac poubelle',
        'Animal domestique',
        'Compote de pommes',
        'Basket-ball',
        'Frites',
        'Crabe royal',
        'Framboise',
        'Trottinette',
        'Boisson gazeuse',
        'Weight Watchers',
        'Pépites de poulet',
        'Bonbons de Pâques',
        'Jardin',
        'Centrifugeuse',
        'Lumière',
        'Nouilles',
        'Draps',
        'Vinaigre',
        'Riz Basmati',
        'Coriandre',
        'Spaghetti',
        'Eau De Source',
        'Courge',
        'Poivre Noir',
        'Pain hot dog',
        'Perceuse à percussion',
        'Oreiller',
        'Bureau',
        'Gingembre',
        'Bœuf haché maigre',
        'Sou',
        'Nettoyeur haute-pression',
        'Lanière de poulet',
        'Cafetière',
        'Noix',
        'Garniture pour tarte',
        'Filet De Porc',
        'Sauce Tomate',
        'Canneberge',
        'Trempette',
        'Plat',
        'Mozzarella',
        'Pétoncles',
        'Serviette',
        'Sauce Barbecue',
        'Bouteille',
        'Bouillon',
        'Boîte en conserve',
        'Oignon Vert',
        'Veste',
        'Supérieur',
        'Terre de jardin',
        'Vitamine',
        'Sacs',
        'Pommes Gala',
        'Porte',
        'Pain hamburger',
        'Lasagne',
        'Pois',
        'Rôti de bœuf',
        'Parapluie',
        'Air',
        'Batterie de cuisine',
        'Vaisselle',
        'Vérin',
        'Préparation pour bébé',
        'Revitalisant',
        'Bois franc',
        'Fer',
        'Cajou',
        'Huile de noix de coco',
        'Boulette de viande',
        'Échelle',
        'Carte SD',
        'Filet de cargaison',
        'Limonade',
        'Burger de poulet',
        'Ragoût de boeuf',
        'Bâtonnets de poulet',
        'Poitrine de poulet désossée',
        'Longe de porc',
        'Porc rôti',
        'Cuisses de poulet',
        'Pâté au poulet',
        'Soupe de nouilles au poulet',
        'Biscuit graham',
        'Pilon de poulet',
        'Épaule de porc',
    ],
}

// Public Definitions -------------------------------------------------------->

export function findSearchItems(
    locale: string,
    searchTerm: string,
    maxItems?: number
) {
    if (!searchTerm) return []

    const localeSegments = locale.split('-')
    const searchItems = items[localeSegments[0]] || []

    let resultItems = searchItems.filter(
        (item) => item.toLowerCase().indexOf(searchTerm.toLowerCase()) === 0
    )
    if (maxItems && resultItems.length > maxItems) {
        resultItems = resultItems.slice(0, maxItems)
    }
    return resultItems
}
